<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import productivityChart from "@/components/Charts/productivityChart.js";
import { formatDate } from "@/utils/formatDate";
import LineChart from "@/components/Charts/LineChart.vue";

const { chartOptions, icons } = productivityChart;

const props = defineProps({
  construction: {
    type: Object,
    required: true,
  },
});

const store = useStore();
const productivity = ref({});
const isLoading = ref(true);

const clickedChartButton = computed(
  () => store.getters["clickedButton/getClickedChartButton"],
);

const data = {
  0: "productchartList",
  1: "ttkchartList",
  2: "packagechartList",
  3: "materialchartList",
};

const chartData = ref({
  labels: [],
  datasets: [],
});

const updateChartData = () => {
  const labels = productivity.value[data[clickedChartButton.value]].map((e) =>
    formatDate(e.date.seconds),
  );
  const plan = productivity.value[data[clickedChartButton.value]].map(
    (e) => e.plan,
  );
  const fact = productivity.value[data[clickedChartButton.value]].map(
    (e) => e.fact,
  );
  const maxValue = Math.max(Math.max(...plan), Math.max(...fact));

  chartData.value = {
    labels: [...new Set(labels)],
    datasets: [
      {
        label: "Plan",
        data: plan,
        borderColor: "red",
        backgroundColor: "red",
        pointBorderColor: "red",
        pointBackgroundColor: "red",
        fill: false,
        tension: 0.1,
      },
      {
        label: "Fact",
        data: fact,
        borderColor: "green",
        backgroundColor: "green",
        pointBorderColor: "green",
        pointBackgroundColor: "green",
        fill: false,
        tension: 0.1,
      },
    ],
  };
  chartOptions.scales.y.suggestedMax = maxValue * 1.1;
};

const {
  ValueRequest_String,
} = require("../../../proto-out/IMultiStatisticsService_pb");

const {
  MultiStatisticsServiceClient,
} = require("../../../proto-out/IMultiStatisticsService_grpc_web_pb");

let authToken = computed(() => store.getters["users/tokenUser"]);
let serverUrl = computed(() => store.getters["appData/getServerUrl"]);

const fetchDataFromGrpc = async () => {
  try {
    const client = new MultiStatisticsServiceClient(serverUrl.value);
    const metadata = { Authorization: `Bearer ${authToken.value}` };
    const request = new ValueRequest_String();
    request.setValue(props.construction.actualinstance);

    const getProductionCollapseData = await new Promise((resolve, reject) => {
      client.getProductionCollapse(request, metadata, (err, response) => {
        if (err) {
          console.error("gRPC Error:", err.message);
          reject(new Error("Failed to fetch data from gRPC"));
        } else {
          resolve(response.toObject());
        }
      });
    });
    productivity.value = getProductionCollapseData;
    isLoading.value = false;
    updateChartData();
  } catch (error) {
    console.error(error);
    // throw error;
  }
  isLoading.value = false;
};
onMounted(() => {
  fetchDataFromGrpc();
});

watch(clickedChartButton, updateChartData);
</script>

<template>
  <v-container fluid class="pa-0 mb-5">
    <!-- TODO data -->
    <v-row align="center" class="mx-auto" style="width: 50%">
      <v-col cols="7">
        <v-card-text align="center" class="date"
          >К ДАТЕ: 12.02.2024</v-card-text
        >
      </v-col>
      <v-col cols="5">
        <v-card class="red-card" width="199">
          <span class="red-card-text">- 2 дн.</span>
          <span class="legend-text ml-3">ПРОГНОЗ</span>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <LineChart
    height="55"
    :chartData="chartData"
    :chartOptions="chartOptions"
    :icons="icons"
  />

  <v-row class="mt-5" style="width: 100%">
    <v-col></v-col>
    <v-col>
      <v-row align="center">
        <v-col cols="4">
          <v-img src="@/assets/icons/green_line.svg" height="7" />
        </v-col>
        <v-col class="px-0">
          <v-card-text
            align="left"
            style="font-size: 18px; color: #1bc200"
            class="px-0"
          >
            ПЛАН
          </v-card-text>
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-row align="center">
        <v-col cols="4">
          <v-img src="@/assets/icons/blue_line.svg" height="7" />
        </v-col>
        <v-col class="px-0">
          <v-card-text
            align="left"
            style="font-size: 18px; color: #52a3db"
            class="px-0"
          >
            ФАКТ
          </v-card-text>
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-row align="center">
        <v-col cols="4">
          <v-img src="@/assets/icons/red_line.svg" height="7" />
        </v-col>
        <v-col class="px-0">
          <v-card-text
            align="left"
            style="font-size: 18px; color: red"
            class="px-0"
          >
            ОТКЛОНЕНИЕ
          </v-card-text>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="col-2" align="end">
      <v-btn rounded="lg" height="3vw" style="font-size: 0.8vw"> ЭКСПОРТ</v-btn>
    </v-col>
  </v-row>
</template>

<style scoped>
.date {
  font-size: 1.5vw;
  color: #00a3ff;
  font-weight: bold;
}
.title {
  color: white;
  background: linear-gradient(#006aa6 0%, #002940);
  font-size: 1.5vw;
  border-radius: 8px;
}
.legend-text {
  font-size: 0.7vw;
}
.red-card {
  background-color: red;
}
.red-card-text {
  font-size: 1.6vw;
}
</style>
